import { render, staticRenderFns } from "./AtendimentoListar.vue?vue&type=template&id=06381104&scoped=true"
import script from "./AtendimentoListar.vue?vue&type=script&lang=js"
export * from "./AtendimentoListar.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoListar.vue?vue&type=style&index=0&id=06381104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06381104",
  null
  
)

export default component.exports